import React from "react";
import { Button, DropdownButton, Dropdown, Form, Tabs, Tab, Modal, ToggleButton } from 'react-bootstrap';
import { Nav, ListGroup } from 'react-bootstrap';
import { context } from '../../AppContext';
import Flow from "../../flow/Flow";
import ConfigRaw from "./ConfigRaw";

export default class SiteParams extends React.Component {

    state = {
        raw: false
    };
    configTextAreaRef = React.createRef();

    render() {
        let didChange = JSON.stringify(this.props.detailScreen.state.itemData) !== JSON.stringify(this.props.detailScreen.state.origItemData);
        return (
            <div className="SiteParams">
                <div style={{ display: "block" }}>
                    <div style={{ display: "inline-block", width: "30%", marginRight: 10 }}>
                        <Form.Group>
                            <Form.Label>Name</Form.Label>
                            <Form.Control 
                                type="text"
                                value={this.props.detailScreen.state.itemData.name || ""}
                                onChange={ (event) => this.props.detailScreen.setState({ itemData: { ...this.props.detailScreen.state.itemData, name: event.target.value } }) }
                            />
                        </Form.Group>
                    </div>
                    <div style={{ display: "inline-block", width: "30%", marginRight: 10 }}>
                        <Form.Group>
                            <Form.Label>Maintainer</Form.Label><br/>
                            { this.props.detailScreen.state.itemData.maintainer
                                ? this.props.detailScreen.state.itemData.maintainer.name
                                : "None"
                            }
                            <Button
                                style={{ float: 'right' }}
                                onClick={ this.props.detailScreen.selectMaintainerPushed.bind(this.props.detailScreen) }
                            >Change</Button>
                        </Form.Group>
                    </div>
                        <div style={{ display: "inline-block", width: "30%", marginRight: 10 }}>
                            <Form.Group>
                                <Form.Label>Owner</Form.Label><br/>
                                { this.props.detailScreen.state.itemData.owner
                                    ? this.props.detailScreen.state.itemData.owner.firstName + " " + this.props.detailScreen.state.itemData.owner.lastName 
                                    : "None"
                                }
                                <br/>
                                { this.props.detailScreen.state.itemData.owner
                                    ? this.props.detailScreen.state.itemData.owner.email
                                    : ""
                                }
                                <Button
                                        style={{ float: 'right' }}
                                    onClick={ this.props.detailScreen.selectOwnerPushed.bind(this.props.detailScreen) }
                                >Change</Button>
                            </Form.Group>
                        </div>
                </div>
                <div style={{ display: "block" }}>
                    <div style={{ display: "inline-block", width: "30%", marginRight: 10 }}>
                        <Form.Group>
                            <Form.Label>Country</Form.Label>
                            <Form.Control 
                                type="text"
                                value={this.props.detailScreen.state.itemData.country || ""}
                                onChange={ (event) => this.props.detailScreen.setState({ itemData: { ...this.props.detailScreen.state.itemData, country: event.target.value } }) }
                            />
                        </Form.Group>
                    </div>
                    <div style={{ display: "inline-block", width: "30%", marginRight: 10 }}>
                        <Form.Group>
                            <Form.Label>State</Form.Label>
                            <Form.Control 
                                type="text"
                                value={this.props.detailScreen.state.itemData.state || ""}
                                onChange={ (event) => this.props.detailScreen.setState({ itemData: { ...this.props.detailScreen.state.itemData, state: event.target.value } }) }
                            />
                        </Form.Group>
                    </div>
                    <div style={{ display: "inline-block", width: "30%", marginRight: 10 }}>
                        <Form.Group>
                            <Form.Label>Zip</Form.Label>
                            <Form.Control 
                                type="text"
                                value={ this.props.detailScreen.state.itemData.zip || ""}
                                onChange={ (event) => this.props.detailScreen.setState({ itemData: { ...this.props.detailScreen.state.itemData, zip: event.target.value } }) }
                            />
                        </Form.Group>
                    </div>
                </div>
                <div style={{ display: "block" }}>
                    <div style={{ display: "inline-block", width: "30%", marginRight: 10 }}>
                        <Form.Group>
                            <Form.Label>City</Form.Label>
                            <Form.Control 
                                type="text"
                                value={this.props.detailScreen.state.itemData.city || ""}
                                onChange={ (event) => this.props.detailScreen.setState({ itemData: { ...this.props.detailScreen.state.itemData, city: event.target.value } }) }
                            />
                        </Form.Group>
                    </div>
                    <div style={{ display: "inline-block", width: "30%", marginRight: 10 }}>
                        <Form.Group>
                            <Form.Label>Address</Form.Label>
                            <Form.Control 
                                type="text"
                                value={this.props.detailScreen.state.itemData.address || ""}
                                onChange={ (event) => this.props.detailScreen.setState({ itemData: { ...this.props.detailScreen.state.itemData, address: event.target.value } }) }
                            />
                        </Form.Group>
                    </div>
                </div>
                <div style={{ display: "block" }}>
                    <div style={{ display: "inline-block", width: "30%", marginRight: 10 }}>
                        <Form.Group>
                            <Form.Label>Latitude</Form.Label>
                            <Form.Control 
                                type="text"
                                value={this.props.detailScreen.state.itemData.latitude || ""}
                                onChange={ (event) => this.props.detailScreen.setState({ itemData: { ...this.props.detailScreen.state.itemData, latitude: event.target.value } }) }
                            />
                        </Form.Group>
                    </div>
                    <div style={{ display: "inline-block", width: "30%", marginRight: 10 }}>
                        <Form.Group>
                            <Form.Label>Longitude</Form.Label>
                            <Form.Control 
                                type="text"
                                value={this.props.detailScreen.state.itemData.longitude || ""}
                                onChange={ (event) => this.props.detailScreen.setState({ itemData: { ...this.props.detailScreen.state.itemData, longitude: event.target.value } }) }
                            />
                        </Form.Group>
                    </div>
                    <div style={{ display: "inline-block", width: "25%", marginRight: 10 }}>
                        <Form.Group>
                            <Form.Label>Weather</Form.Label><br/>
                            { this.props.detailScreen.state.weather?.current?.temp || "-" } / 
                            { this.props.detailScreen.state.weather?.current?.weather[0].description || "-" }
                            <DropdownButton id="dropdown-basic-button" title={ "Options" } style={{ display: 'inline-block', marginLeft: 20 }}>
                                <Dropdown.Item onClick={ () => { this.props.detailScreen.showWeatherPushed() }}>Details</Dropdown.Item>
                                <Dropdown.Item onClick={ () => { this.props.detailScreen.updateWeather(true) }}>Force Update</Dropdown.Item>
                            </DropdownButton>
                        </Form.Group>
                    </div>
                </div>
                <div style={{ display: "block" }}>
                    <div style={{ display: "inline-block", width: "70%", marginRight: 10 }}>
                        Assigned Devices:
                        <div>
                            <ListGroup>
                            { this.props.detailScreen.state.itemData.devices.length > 0 ? this.props.detailScreen.state.itemData.devices.map(item => {
                                let osVersion = this.props.detailScreen.state.itemStatus?.find(st => st.item === item.uuid && st.name === "OsVersion" )?.state;
                                let versionObj = context.resolveVersion(osVersion);
                                return (
                                    <ListGroup.Item 
                                        action 
                                        key={item.uuid} 
                                        href={ "#/devices/" + item.uuid }
                                        className="listItem"
                                    >
                                        <div style={{ float: 'left', marginRight: 20 }}>
                                            { context.isConnected(item.uuid) !== false ? 
                                                (<span style={{ color: "green" }}>Online</span>) : 
                                                (<span style={{ color: "red" }}>Offline</span>)
                                            }
                                        </div> 
                                        <div style={{ float: 'left', marginRight: 20 }}>{ item.deviceNumber || "-" }</div> 
                                        <div style={{ float: 'left', marginRight: 20 }}>{ item.uuid }</div>  
                                        <div style={{ float: 'right', 
                                            color: this.props.detailScreen.state.vpnPing[item.uuid] ? (
                                                this.props.detailScreen.state.vpnPing[item.uuid]?.success ? "green" : "red"
                                            ) : "black"
                                        }}>
                                            { item.vpnAddress }
                                        </div> 
                                        <div style={{ float: 'right', marginRight: 10 }}>{ versionObj?.Version || 'N/A' }</div> 
                                    </ListGroup.Item> 
                                    );
                                }) : (
                                    <div>
                                        None Assigned
                                        <Button 
                                            style={ { backgroundColor: "blue", marginRight: 10, float: 'left' } }
                                            onClick={ this.props.detailScreen.associateRecord.bind(this.props.detailScreen, false) }
                                        >Assign</Button>
                                    </div> 
                                )
                            }
                            </ListGroup>
                        </div>
                    </div>
                    <div style={{ display: "inline-block", width: "25%", marginRight: 10 }}>
                        <Form.Group>
                            <Button
                                id="pingVpn"
                                onClick={(event) => { 
                                    this.props.detailScreen.pingVpnAddress();
                                }}
                            >Ping Vpn</Button>
                        </Form.Group>
                    </div>
                </div>
                <div style={{ paddingTop: 30 }}>
                    <div style={{ display: "inline-block", width: "25%", marginRight: 10 }}>
                        <Form.Group>
                            <Form.Switch
                                id="monitored"
                                label="Is Monitored"
                                checked={ this.props.detailScreen.state.itemData.monitored }
                                onChange={(event) => { 
                                    this.props.detailScreen.setState({ itemData: { ...this.props.detailScreen.state.itemData, monitored: event.target.checked } }) ;
                                }}
                            />
                        </Form.Group>
                    </div>
                </div>
                <div style={{ paddingTop: 30 }}>
                    <div className="floatLeft">
                        Created: { this.props.detailScreen.state.itemData.created } <br/>
                        Uuid: { this.props.detailScreen.state.itemData.uuid } <br/>
                        Owner: {
                            this.props.detailScreen.state.itemData.owner ? 
                            <a href={ "#/users/" + this.props.detailScreen.state.itemData.owner?.uuid }>{ this.props.detailScreen.state.itemData.owner?.firstName + " " + this.props.detailScreen.state.itemData.owner?.lastName }</a> 
                            : "None"
                        }
                        <br/>
                        { this.props.detailScreen.state.itemData.deleted === 1 ? (<div style={{ color: "red" }}>Deleted</div>) : (
                            <div>
                                <Button 
                                    hidden={ this.props.detailScreen.state.itemData.deleted === true || this.props.detailScreen.state.itemData.userId !== null }
                                    style={ { backgroundColor: "red", marginRight: 10 } }
                                    onClick={ this.props.detailScreen.deleteRecord.bind(this.props.detailScreen, false) }
                                >Delete</Button>
                                <Button 
                                    hidden={ this.props.detailScreen.state.itemData.userId === null }
                                    style={ { backgroundColor: "red", marginRight: 10 } }
                                    onClick={ this.props.detailScreen.disassociateRecord.bind(this.props.detailScreen, false) }
                                >Disassociate</Button>
                            </div>
                        ) }
                        
                    </div>
                    <div className="floatRight">
                        Last seen: { this.props.detailScreen.state.itemData.lastSeen } <br/>
                        <Button disabled={ !didChange }
                            onClick={ this.props.detailScreen.saveRecord.bind(this.props.detailScreen) }
                        >Save</Button>
                    </div>
                </div>
            </div>
        );
    }
}